let rowCount = 0;

document.addEventListener('DOMContentLoaded', () => {

  if (document.getElementById('wof_product_table') != null) {
    setTimeout(processOrderTable, 1000)
  }
  
})

function processOrderTable() {
  if (document.querySelectorAll('.qtyPerVariant').length > rowCount) {
    document.querySelectorAll('.qtyPerVariant').forEach((e) => {
      let qty = e.innerHTML;
      if (qty < 0) {
        e.innerHTML = 0;
      }
    });      
  }

  setTimeout(processOrderTable, 3000);
}